import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../auth.jsx'
import { Alert } from '../lib.jsx'

export default function Login() {
  const { login } = useAuth()
  const nav = useNavigate()
  const loc = useLocation()
  const [u, setU] = useState('')
  const [p, setP] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setErr(''); setBusy(true)
    try {
      await login(u, p)
      const from = loc.state?.from
      const destination = from?.pathname && from.pathname !== '/'
        ? `${from.pathname}${from.search || ''}${from.hash || ''}`
        : '/migration'
      nav(destination, { replace: true })
    } catch (e) { setErr(e.status === 401 ? 'Błędny login lub hasło' : (e.message || 'Błąd logowania')) }
    finally { setBusy(false) }
  }

  return (
    <div className="login-wrap">
      <div className="card login-card">
        <div className="brand"><div className="logo">G</div><b>generator<span>PDF</span></b></div>
        <div className="tag">Szablony AI · skład dokumentów · eksport PDF/PPTX</div>
        <form onSubmit={submit}>
          <Alert kind="err">{err}</Alert>
          <div className="field"><label>Użytkownik</label>
            <input value={u} onChange={e => setU(e.target.value)} autoFocus autoComplete="username" /></div>
          <div className="field"><label>Hasło</label>
            <input type="password" value={p} onChange={e => setP(e.target.value)} autoComplete="current-password" /></div>
          <button className="btn btn-primary" style={{ width: '100%' }} disabled={busy || !u || !p}>
            {busy ? 'Logowanie…' : 'Zaloguj się'}
          </button>
        </form>
        <div className="tag" style={{ marginTop: 16 }}>To samo konto co panel aihub — wspólne logowanie.</div>
      </div>
    </div>
  )
}
